import { Button } from '@mui/material';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { GTM, GTMButtons, GTMLocations } from 'utils/analytics';

type Props = {
  className?: string;
  likeCallback?: () => void;
};

const CallToSignupMiniBanner = (props: Props) => {
  const { t } = useTranslation();
  const { className, likeCallback } = props;

  // Track if button was clicked
  const handleCallToAction = async () => {
    GTM.buttonClicked(GTMButtons.SIGNUP, GTMLocations.LISTING_PAGE);
    if (typeof likeCallback === 'function') {
      likeCallback();
    }
  };

  return (
    <div key="b" className={classNames('calltosignup-minibanner', className)}>
      <div className="calltosignup-minibanner_content">
        <img src="/icons/icn-heart-label.svg" alt="" className="calltosignup-minibanner-icon" />
        <div className="calltosignup-minibanner_content-inner">
          <h4>{t('components.calltosignup-minibanner.title')}</h4>
          <p>{t('components.calltosignup-minibanner.description')}</p>
        </div>
      </div>
      <div className="calltosignup-minibanner-button">
        <Button variant="outlined" color="primary" onClick={() => handleCallToAction()}>
          {t('components.calltosignup-minibanner.button')}
        </Button>
      </div>
    </div>
  );
};

export default CallToSignupMiniBanner;
